import type { UesFieldDef } from "../entities/doc-type"
import type { DocTypeRepository } from "../repositories/doc-type-repository"

type UpdateDocTypeInput = {
  displayName: string
  description: string
  uesFields: UesFieldDef[]
}

export const makeUpdateDocType = (repo: DocTypeRepository) =>
  (id: string, input: UpdateDocTypeInput) => repo.update(id, input)
